import { createAsyncThunk } from "@reduxjs/toolkit";

const API_BASE = process.env.REACT_APP_API_BASE;
const API_KEY = process.env.REACT_APP_API_KEY

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data) 
      const res = await fetch(`${API_BASE}/api/auth/app/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": API_KEY
        },
        body: body
      });

      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);



export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": API_KEY,
        },
        body: body,
      });

      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);



export const ResetPasswordToken = createAsyncThunk(
  "auth/ResetPasswordToken",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/reset-password-token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: body,
      });

      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);


export const SetupNewPassword = createAsyncThunk(
  "auth/SetupNewPassword",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/reset-password-token`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
        body: body,
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        window.location.href = "/login";
        return thunkAPI.rejectWithValue("Unauthorized");
      }
      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);
export const SetupMemberPassword = createAsyncThunk(
  "auth/SetupMemberPassword",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/setup-password`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
        body: body,
      });

      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);


export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch(`${API_BASE}/api/auth/app/logout`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
      });

      const json = await res.json();

      if (!res.ok) {
        return rejectWithValue(json?.message || "Logout failed");
      }

      return json; // success message or status
    } catch (err) {
      return rejectWithValue(err.message || "Unexpected error during logout");
    }
  }
);


export const googleLogin = createAsyncThunk(
  "auth/googleLogin",
  async (idToken, { rejectWithValue }) => {
    try {
      const res = await fetch(`${API_BASE}/api/auth/app/google`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ idToken }),
      });

      const data = await res.json();
      
      if (!res.ok) throw new Error(data.message || "Google login failed");

      return data; // return user payload from backend
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
export const microsoftLogin = createAsyncThunk(
  "auth/microsoftLogin",
  async (idToken, { rejectWithValue }) => {
    try {
      const res = await fetch(`${API_BASE}/api/auth/app/microsoft`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ idToken }),
      });

      const data = await res.json();
      
      if (!res.ok) throw new Error(data.message || "Google login failed");

      return data; 
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);